import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
// Can be replaced with native Vue Teleport when on Vue 3
import Teleport from 'vue2-teleport';

import { useRoutingStore } from '@/helpers/composables/useStores';
import { enableScroll } from '@/helpers/scroll-helper';

interface BaseModalProps {
	title?: string;
	subTitle?: string;
	closable?: boolean;
	hasHeader?: boolean;
	hasFooter?: boolean;
	disableTeleport?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModalNew',
  props: {
    title: { default: '' },
    subTitle: { default: '' },
    closable: { type: Boolean, default: true },
    hasHeader: { type: Boolean, default: true },
    hasFooter: { type: Boolean, default: false },
    disableTeleport: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close', display: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const { activeRoute } = useRoutingStore();





const close = () => {
	emit('close', false);
};

const activeRouteName = computed(() => activeRoute.value);
watch(activeRouteName, () => {
	enableScroll();
	emit('close', false);
});

return { __sfc: true,activeRoute, emit, close, activeRouteName, Teleport }
}

})